<mat-list-item matRipple routerLinkActive="active">
  <ng-content></ng-content>
</mat-list-item>
